import { render, staticRenderFns } from "./manage-offers.vue?vue&type=template&id=77a35a2e&scoped=true&"
import script from "./manage-offers.vue?vue&type=script&lang=js&"
export * from "./manage-offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a35a2e",
  null
  
)

export default component.exports